export function buildEditorLink(zapId: string, isPublished: boolean) {
  const prompt = "Help me finish setting up my Zap";

  return isPublished
    ? `/editor/${zapId}`
    : `/editor/${zapId}?copilot_prompt=${encodeURIComponent(prompt)}`;
}
